import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { GbMessageDialogComponent } from './gb-message-dialog/gb-message-dialog.component'

import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { GbBackButtonComponent } from './gb-back-button/gb-back-button.component'
import { GbBidSuccessAnimationComponent } from './gb-bid-success-animation/gb-bid-success-animation.component'
import { GbDonationSuccessAnimationComponent } from './gb-donation-success-animation/gb-donation-success-animation.component'
import { GbErrorAnimationComponent } from './gb-error-animation/gb-error-animation.component'
import { GbPaymentSuccessAnimationComponent } from './gb-payment-success-animation/gb-payment-success-animation.component'
import { GbPurchaseSuccessAnimationComponent } from './gb-purchase-success-animation/gb-purchase-success-animation.component'
import { GbRaffleSuccessAnimationComponent } from './gb-raffle-success-animation/gb-raffle-success-animation.component'
import { GbTicketSuccessAnimationComponent } from './gb-ticket-success-animation/gb-ticket-success-animation.component'
import { GbActivityFeedPostCreateComponent } from 'libs/gb-front/activity-feed/feature/src/lib/gb-activity-feed-post-create/gb-activity-feed-post-create.component'
import { MatToolbarModule } from '@angular/material/toolbar'
import { LayoutModule } from '@angular/cdk/layout'

@NgModule({
  declarations: [
    GbMessageDialogComponent,
    GbBackButtonComponent,
    GbBidSuccessAnimationComponent,
    GbErrorAnimationComponent,
    GbDonationSuccessAnimationComponent,
    GbPurchaseSuccessAnimationComponent,
    GbRaffleSuccessAnimationComponent,
    GbPaymentSuccessAnimationComponent,
    GbTicketSuccessAnimationComponent,
  ],
  imports: [
    MatIconModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatToolbarModule,
    TranslateModule,
    GbActivityFeedPostCreateComponent,
    LayoutModule,
  ],
  exports: [GbBackButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GbFrontSharedUtilModule {}
